import { styledPolymorphic } from '@qred/components-library';

export const CheckpointStepContent = styledPolymorphic<'div', {}>()((_styled) =>
  _styled(({ theme }) => ({
    display: 'grid',
    width: '100%',
    height: '100%',
    overflow: 'auto',

    [theme.fn.largerThan('tablet')]: {
      backgroundImage: 'url(/qrayon22_10percent.png)',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      alignItems: 'center',
      alignContent: 'center',
      gridTemplateColumns: '1fr 40em 1fr',
    },

    '> *': {
      gridColumn: '2',
      padding: '24px 16px',
      backgroundColor: theme.fn.themeColor('Page/Option_1_(White)'),

      [theme.fn.largerThan('tablet')]: {
        padding: '24px',
      },
    },
  }))
);
